import { CircularProgress, Link, Typography } from '@mui/material'
import React from 'react'
import { Link as ReactRouterLink } from 'react-router-dom'

interface LabelFieldProps {
  ellipsis?: boolean
  error?: boolean
  isLoading?: boolean
  label?: React.ReactNode
  onClick?: () => void
  to?: string
  value?: string | number | React.ReactNode
}

export default function LabelField({ ellipsis = false, error, isLoading, label, onClick, to, value }: LabelFieldProps) {
  return (
    <>
      <Typography variant='body2'>{label}</Typography>

      <Typography
        color={error ? 'error' : 'primary'}
        fontWeight={Boolean(value) ? 'inherit' : 'bold'}
        variant='body1'
        sx={{
          textOverflow: ellipsis ? 'ellipsis' : 'inherit',
          minHeight: '24px',
          overflow: 'hidden',
          whiteSpace: 'nowrap'
        }}
      >
        {isLoading ? (
          <CircularProgress size={16} />
        ) : onClick ? (
          <Link onClick={onClick} sx={{ cursor: 'pointer' }}>
            {value}
          </Link>
        ) : to ? (
          <Link
            {...(to && (to.startsWith('http') || to.startsWith('mailto') || to.startsWith('tel'))
              ? { href: to }
              : { to, component: ReactRouterLink })}
          >
            {value}
          </Link>
        ) : Boolean(value) ? (
          value
        ) : (
          '-'
        )}
      </Typography>
    </>
  )
}
